// 数据处理
class PrizeActivitiesExchange {
  constructor() {
    this.init();
    this.PopupController = "";
    this.userPoints = 0;
  }
  init() {
    this.getTicketsCount();
    this.imgClick();
    window.VOGRACE.eventBus.on("popup:open", (_, __, res) => {
      this.PopupController = res;
    });
    this.exchangeSubmit();
    this.exchangeCancel();
    this.exchangeButtonClick();
    this.getExchangeDialogCloseButton();
    this.getExchangeDialogOverlay();
    this.getPoints();
  }

  // 查询还有多少票
  async getTicketsCount() {
    const apiHost = VogUtils.getApiHost();
    const url = `${apiHost}/getTicketsCount`;
    // const res = await fetch(url).then(res => res.json());
    const _fetch = window.VOGRACE.fetch;
    const customerId = customer_id || localStorage.getItem("chat_token") || 0;
    const ticketsEl = document.getElementById("tickets");
    const exchangeBtn = document.getElementById("exchangeButton");
    try {
      const res = await _fetch
        .post(url, { customer_id: customerId })
        .then((res) => res.json());
      // 统一处理票数逻辑
      const remainingTickets = Number(res.total_tickets_exchanged) || 30;
      ticketsEl.textContent = `Remaining Tickets: ${remainingTickets}`;
      const shouldHideButton = remainingTickets === 0;
      exchangeBtn.dataset.visibility =
        shouldHideButton || res.has_exchanged ? "hidden" : "visible";
      ticketsEl.dataset.visibility = "visible";
    } catch {
      ticketsEl.dataset.visibility = "visible";
    }
  }
  exchangeButtonClick() {
    const exchangeButton = document.getElementById("exchangeButton");
    exchangeButton.addEventListener("click", (e) => {
      // todo  先将弹窗隐藏
      this.PopupController.close();
      // 校验是否登录
      if (!customer_id) {
        window.VOGRACE.showLoginPopup();
        return;
      } else {
        // const points = this.getPoints()
        // 校验积分是否满2000
        if (this.userPoints < 2000) {
          return VogUtils.showMessage("Insufficient points!", "default");
        } else {
          this.PopupController.open();
        }
      }
    });
  }
  async getPoints() {
    // const pointsEvent = document.getElementById('UserPointsBalance');
    try {
      const res = await VogUtils.getFactory({
        url: "/account/currentAccountInfo",
        method: "GET",
      });
      this.userPoints = Number(res.points);
    } catch (error) {
      console.log(error);
    }
  }
  imgClick() {
    document.querySelector(".priceImgDiv").addEventListener("click", (e) => {
      const img = e.target.closest(".priceImg");
      if (!img) return;
      if (!customer_id) {
        window.VOGRACE.showLoginPopup();
        return;
      } else {
        const imgPoint = img.dataset.point;
        // const imgUrl = img.dataset.url
        const productId = img.dataset.productid;
        const points = this.userPoints;
        if (points <= Number(imgPoint)) {
          VogUtils.showMessage("Insufficient points!", "default");
        } else {
          console.log(Number(points), Number(imgPoint));
          // window.location.href = location.origin + imgUrl
          const content = window.i18n.t("exchange_or_not", {
            v1: imgPoint,
            v2: points,
          });
          VogUtils.JQMessageBox.confirm(content)
            .then(async () => {
              console.log("用户点击了确定"); // 现在可以正确执行
              const data = { productId: productId };
              const res = await VogUtils.fetchFactory({
                url: "/account/exchangeExpressCoupon",
                method: "POST",
                data,
                contentType: "multipart/form-data",
              });
              layer.open({
                title: window.i18n.t("whether_to_copy_the_successful_exchange"),
                content: res.couponCode,
                skin: "pt-0",
                btn: [window.i18n.t("copy"), window.i18n.t("cancel")],
                yes: () => {
                  layer.msg(window.i18n.t("copy_successfully"));
                  VogUtils.fallbackCopyTextToClipboard(res.couponCode);
                  location.reload(true);
                },
              });
            })
            .catch(() => {
              console.log("用户取消操作");
            });
        }
      }
    });
  }
  exchangeSubmit() {
    $vog("#exchange-popup-form").submit(async (event) => {
      event.preventDefault();
      const _fetch = window.VOGRACE.fetch;
      const form = document.getElementById("exchange-popup-form");

      const emailInput = document.getElementById("exchangeEmail");
      const email = emailInput.value.trim();
      //  校验邮箱提示
      const emailRegex = /@/;
      if (!emailRegex.test(email)) {
        event.preventDefault(); // 阻止表单提交
        emailInput.setCustomValidity(
          "Please include '@' in your email address！"
        );
        emailInput.reportValidity(); // 触发提示
        return;
      } else {
        emailInput.setCustomValidity(""); // 清除错误提示
      }
      const formData = new FormData(form);
      const data = Object.fromEntries(formData);
      const apiHost = VogUtils.getApiHost();
      const url = `${apiHost}/account/exchangeTickets`;
      // const res=await _fetch.post(url, data)
      const domain = VogUtils.getShopDomainEnv();
      try {
        const res = await _fetch.post(url, data, {
          headers: {
            "customer-id": customer_id || localStorage.getItem("chat_token"),
            timestamp: now_timestamp,
            sign: customer_slat,
            "shop-domain": domain,
          },
        });
        const resJson = await res.json(); // 确保解析 JSON 数据
        console.log("API Response:", resJson);
        // 统一处理响应消息
        const message =
          resJson.code === 200
            ? resJson.data.message
            : resJson.message || "something_went_wrong";
        VogUtils.JQMessageBox.alert(message).then(() => {
          this.PopupController.close();
          this.resetForm();
          this.getTicketsCount();
        });
        // VogUtils.showMessage(message, 'default');
        // // 无论成功/失败都执行清理操作
        // setTimeout(() => {
        //   this.PopupController.close();
        //   this.resetForm();
        //   this.getTicketsCount();
        // }, 3000);
      } catch (error) {
        console.error("API Error:", error);
        // 增强错误处理
        const errorMessage =
          error.data?.message || error.message || "something_went_wrong";

        // VogUtils.showMessage(errorMessage, 'default');
        VogUtils.JQMessageBox.alert(errorMessage).then(() => {
          this.PopupController.close();
          this.resetForm();
          this.getTicketsCount();
        });
      }

      // _fetch.post(url, data, {
      //   headers: {
      //     "customer-id": customer_id || localStorage.getItem("chat_token"),
      //     timestamp: now_timestamp,
      //     sign: customer_slat,
      //     "shop-domain": domain,
      //   }
      // }
      // ).then(res => {
      //   const resJson = res.json()
      //   console.log(res,resJson,resJson.code)
      //   debugger
      //   if (resJson) {
      //     if (resJson.code === 200) {
      //       VogUtils.showMessage(`${resJson.data.message}`, 'default')
      //     } else if (resJson.code === 500) {
      //       VogUtils.showMessage(`${resJson.message}`, 'default')
      //     } else {
      //       VogUtils.showMessage("something_went_wrong", 'default')
      //     }
      //   }
      //   setTimeout(() => {
      //     this.PopupController.close()
      //     this.resetForm()
      //   }, 3000)
      // }).catch((error) => {
      //   if (error.data.code === 500 && error.data.message) {
      //     VogUtils.showMessage(`${error.data.message}`, 'default')
      //   } else {
      //     VogUtils.showMessage("something_went_wrong", 'default')
      //   }
      // })
    });
  }
  exchangeCancel() {
    document
      .querySelector(".exchange-dialog-cancel-button")
      .addEventListener("click", (e) => {
        e.preventDefault();
        this.PopupController.close();
        this.getTicketsCount();
        this.resetForm();
      });
  }
  // 点击弹窗的关闭按钮清空表单数据
  getExchangeDialogCloseButton() {
    document
      .querySelector(".vograce-popup__close-button")
      .addEventListener("click", (e) => {
        e.preventDefault();
        this.resetForm();
        this.getTicketsCount();
      });
  }
  // vograce-popup__overlay
  getExchangeDialogOverlay() {
    document.querySelector(".vograce-overlay").addEventListener("click", (e) => {
      e.preventDefault();
      this.resetForm();
      this.getTicketsCount();
    });
  }
  resetForm() {
    document.getElementById("exchange-popup-form").reset();
  }
}

VogUtils.DOMready(() => {
  new PrizeActivitiesExchange();
});
